// ABOUTME: Initiative dialog hook using global dialog store
// ABOUTME: Manages initiative dialog state

import { useGlobalDialogs } from "@/shared/model/global-dialogs";

const DIALOG_ID = "initiative";

export function useInitiativeDialog() {
  const { isOpen, open: openDialog, close } = useGlobalDialogs();

  return {
    isOpen: isOpen(DIALOG_ID),
    setIsOpen: (open: boolean) => (open ? openDialog(DIALOG_ID) : close()),
    open: () => openDialog(DIALOG_ID),
    close,
  };
}
